export class FibberglassConstants {
  public readonly MakeLaunch: number = 2;
  public readonly FullLaunch: Array<string> = [ "1", "3", "4" ];
  public readonly FalokaLaunch: number = 7;
  public readonly FastPassLaunch: number = 4;
  public readonly Volt380on220: number = 12;
  public readonly base64Image: string = ``;
}